import React, {useEffect, useState} from 'react'
import {Container} from 'react-bootstrap'
import {AES, enc} from 'crypto-js'
import {Filespreview} from '../../sharedComponent/Preview'
import {useSearchParams} from 'react-router-dom'
import {uploadFiles} from '../../../utils/helper'
import {useLazyQuery, useMutation} from '@apollo/client'
import {VALIDATE_LINK, UPLOAD_CUSTOMER_BILLS} from '../../../utils/GraphQLAPI'
import {UploadFiles} from '../../sharedComponent/UploadFiles'

const CustomerBill = () => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>(() => [])
  const [loggedIn, setLoggedIn] = useState(false)
  const [uploaded, setuploaded] = useState(() => false)
  const [isLoading, setIsLoading] = useState(true)
  const [isUploading, setIsUploading] = useState(false)
  const [customerInfo, setCustomerInfo] = useState({firstName: '', id: '', billId: '',allowedComponents:['']})
  const [queryParams] = useSearchParams()
  const [FileUploaderror, setFileUploadError] = useState<string | null>(null)

  const [validateLink] = useLazyQuery(VALIDATE_LINK, {
    onCompleted: (data) => {
      setIsLoading(false)
      if (data.validateCustomerForUploading.responseCode === 200) {
        setLoggedIn(true)
      } else if (data.validateCustomerForUploading.responseCode === 404) {
        setLoggedIn(false)
      }
    },
  })
  const [uploadCustomerBills] = useMutation(UPLOAD_CUSTOMER_BILLS, {
    onCompleted: (data) => {
      setuploaded(true)
      setIsUploading(false)
    },
  })
  useEffect(() => {
    const urlParams: any = queryParams.get('billid')
    const decryptedData = JSON.parse(
      AES.decrypt(decodeURIComponent(urlParams), 'gDdoxYdfT5XCJw0y').toString(enc.Utf8)
    )
    setCustomerInfo(decryptedData)
    validateLink({
      variables: {
        trackId: decryptedData?.trackId,
        customerId: decryptedData?.id ?? null,
        billId: decryptedData.billId,
      },
    })
  }, [])

  if (isLoading) {
    return (
      <Container>
        <div className='card card-custom shadow'>
          <div className='card-body'>
            <div>Loading...</div>
          </div>
        </div>
      </Container>
    )
  }
  if (uploaded) {
    return (
      <Container>
        <div className='card card-custom shadow'>
          <div className='card-body'>
            <div className='text-center alert alert-success'>
              <h4 className='fs7'> Bill uploaded successfully</h4>
            </div>
          </div>
        </div>
      </Container>
    )
  }

  return (
    <>
      <Container>
        <div className='card card-custom shadow'>
          {loggedIn && (
            <div className='card-header justify-content-center'>
              <h3 className='card-title'>Hi Customer, please upload your bill image</h3>
            </div>
          )}
          <div className='card-body'>
            {loggedIn ? (
              <>
                <UploadFiles
                  isMultiple={true}
                  setUploadedFiles={setUploadedFiles}
                  fileTypes='image/*,application/pdf'
                  labelText={Array.isArray(customerInfo?.allowedComponents) && 
                    customerInfo?.allowedComponents.includes('changeBillImageText') ? 
                    'Agent Photo Required. Bill Images should be added after Selfie' : 
                    'Please upload image(s) or a PDF'}
                                  buttontext={uploadedFiles.length !== 0 ? 'Add more' : 'Select bills to upload'}
                  setFileUploadError={setFileUploadError}
                  FileUploaderror={FileUploaderror}
                />
                <div>
                  <Filespreview
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    removeFile={(file) =>
                      setUploadedFiles((prev: File[]) =>
                        prev.filter((prevFile: File) => prevFile?.name !== file?.name)
                      )
                    }
                  />
                </div>
                <button
                  className='btn btn-bg-primary btn-color-white'
                  disabled={uploadedFiles.length < 1}
                  onClick={async () => {
                    setIsUploading(true)
                    const values = await uploadFiles(uploadedFiles, true, 'billimages', 'billpdf')

                    await uploadCustomerBills({
                      variables: {
                        billId: customerInfo?.billId,
                        customerId: customerInfo?.id,
                        urls: values,
                      },
                    })
                  }}
                >
                  {isUploading ? (
                    <>
                      <span>Uploading</span>
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </>
                  ) : (
                    'Upload'
                  )}
                </button>
              </>
            ) : (
              <div className='text-center alert alert-danger'>
                <h4 className='fs7'> Your session has expired, please contact your agent</h4>
              </div>
            )}
          </div>
        </div>
      </Container>
    </>
  )
}
export default CustomerBill
